import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const ModelRepository = RepositoryFactory.get('UserPermissionRepository')['ModelRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create, update, remove } = DefaultStoreActions(ModelRepository)

export const STORE_MODULE_NAME = 'user_permission_model';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
        update: update,
        delete: remove,
    },
}
